import Axios from 'axios'
import buildHost from './buildHost'
import { API_HOST } from './host'
import withInterceptors from './interceptor'

export const axiosController = new AbortController()

export const axiosInstance = Axios.create({
	withCredentials: true,
	baseURL: buildHost(API_HOST),
	signal: axiosController.signal,
})

withInterceptors(axiosInstance)

export const generalAxiosInstance = Axios.create({
	baseURL: buildHost(API_HOST),
})

export const { get, post } = axiosInstance
